import FileService from "@services/File";
import Service from "@services/Service";
import Settings from "@settings";
import { WEB_API_ENDPOINT, GROUP_BUCKET } from "@utils/awsAmplify";

class Group extends Service {
  static list(accountId) {
    return Group.get(WEB_API_ENDPOINT, "/mailing_lists", {
      queryStringParameters: {
        account_id: accountId,
      },
    });
  }

  static delete(listId) {
    return Group.del(WEB_API_ENDPOINT, `/mailing_lists/${listId}`);
  }

  static save(data) {
    return Group.put(WEB_API_ENDPOINT, `/mailing_lists/${data.listId}`, {
      body: {
        accountId: data.accountId,
        name: data.name,
      },
    });
  }

  static find(listId) {
    return Group.get(WEB_API_ENDPOINT, `/mailing_lists/${listId}`);
  }

  static addContact(listId, phoneNumber) {
    return Group.put(
      WEB_API_ENDPOINT,
      `/mailing_lists/${listId}/items/${phoneNumber}`
    );
  }

  static deleteContact(listId, phoneNumber) {
    return Group.del(
      WEB_API_ENDPOINT,
      `/mailing_lists/${listId}/items/${phoneNumber}`
    );
  }

  static listContacts(listId) {
    return Group.get(WEB_API_ENDPOINT, `/mailing_lists/${listId}/items`);
  }

  static import(file, fullFileName) {
    return new Promise((resolve, reject) => {
      const bucket = Settings.awsAmplify.Storage[GROUP_BUCKET];
      if (bucket) {
        FileService.upload(bucket, file, fullFileName)
          .then((response) => {
            resolve(response);
          })
          .catch((e) => {
            console.error(e);
            reject("File upload error");
          });
      } else {
        reject("AWS S3 bucket not configured");
      }
    });
  }
}

export default Group;
